import React, { ReactNode } from 'react';

import styles from './UserListItem.scss';
import classNames from 'classnames';

export type UserListItemProps = {
  children: ReactNode;
  picture: ReactNode;
  alignTop?: boolean;
};

export const UserListItem: React.FunctionComponent<UserListItemProps> = ({
  children,
  picture,
  alignTop,
}) => (
  <li
    className={classNames(styles.userListItem, {
      [styles.aligntop]: alignTop,
    })}
  >
    <div className={styles.avatar}>{picture}</div>
    <div className={classNames(styles.content, 'jg-flex-g1')}>{children}</div>
  </li>
);

export default UserListItem;
